import { create } from 'zustand';

interface CheckoutStore {
  gateway: string;
  setGateway: (gateway: string) => void;
  useWallet: boolean;
  setUseWallet: (useWallet: boolean) => void;
}

export const useCheckoutStore = create<CheckoutStore>((set) => ({
  gateway: '',
  setGateway: (gateway: string) => set({ gateway }),
  useWallet: false,
  setUseWallet: (useWallet: boolean) => set({ useWallet }),
}));
